var createPatternBuilder = require('./createPatternBuilder');
module.exports = generateCreateDragForceFunction;
module.exports.generateCreateDragForceFunctionBody = generateCreateDragForceFunctionBody;
function generateCreateDragForceFunction(dimension) {
  var code = generateCreateDragForceFunctionBody(dimension);
  return new Function('options', code);
}
function generateCreateDragForceFunctionBody(dimension) {
  var pattern = createPatternBuilder(dimension);
  var code = "\n  if (!Number.isFinite(options.dragCoefficient)) throw new Error('dragCoefficient is not a finite number');\n\n  return {\n    update: function(body) {\n      ".concat(pattern('body.force.{var} -= options.dragCoefficient * body.velocity.{var};', {
    indent: 6
  }), "\n    }\n  };\n");
  return code;
}